import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/types-known authors & contributors
// SPDX-License-Identifier: Apache-2.0

/* eslint-disable sort-keys */
// structs need to be in order

/* eslint-disable sort-keys */


var sharedTypes = {
  AccountInfo: 'AccountInfoWithProviders',
  Address: 'MultiAddress',
  FullIdentification: '()',
  // No staking, only session (as per config)
  LookupSource: 'MultiAddress',
  Keys: 'SessionKeys6'
};
var versioned = [{
  minmax: [0, 200],
  types: _objectSpread(_objectSpread({}, sharedTypes), {}, {
    Address: 'AccountId',
    LookupSource: 'AccountId'
  })
}, {
  minmax: [201, undefined],
  types: _objectSpread({}, sharedTypes)
}];
export default versioned;